export default {
      id: "units__ignition_symbol-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#units__ignition_symbol",
      toString: function () {
        return this.url;
      }
    }